import { Card, CardContent, Grid } from '@mui/material';
import React from 'react';
import Contact from '../../models/Contact';
import { Palette } from 'Palette';
import { StyledButton } from '../styles/StyledButtons';
import { StyledTypography } from '../styles/styles';

interface PlaceholderContactMatchCardProps {
  contact: Contact;
  tone?: keyof typeof Palette;
  submitting: boolean;
  onReplace: (contactId: string) => void;
}

const PlaceholderContactMatchCard: React.FC<PlaceholderContactMatchCardProps> = ({
  contact,
  tone = 'default',
  submitting,
  onReplace,
}) => (
  <Card sx={{ mb: 2 }}>
    <CardContent>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={8}>
          <StyledTypography variant="h6" tone={tone}>
            {contact.firstName} {contact.lastName}
          </StyledTypography>
          <StyledTypography variant="body2" tone={tone}>
            {contact.email}
          </StyledTypography>
          {contact.mobile && (
            <StyledTypography variant="body2" tone={tone}>
              Mobile: {contact.mobile}
            </StyledTypography>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <StyledButton
            variant="contained"
            onClick={() => onReplace(contact.id)}
            disabled={submitting}
          >
            Replace with this contact
          </StyledButton>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default PlaceholderContactMatchCard;
